import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { StudentAIInterviewType } from '@agent-ds/shared/enums';
import { StudentDetail } from '@agent-ds/shared/interfaces';
import { StudentApiService } from '@agent-ds/shared/services';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'ag-student-gps-academic-csv-dialog',
  templateUrl: './student-gps-academic-csv-dialog.component.html',
  styleUrls: ['./student-gps-academic-csv-dialog.component.scss'],
})
export class StudentGPSAcademicCSVDialogComponent implements OnInit, OnDestroy {
  @ViewChild('fileinput', { static: false }) private fileInput: HTMLInputElement;

  constructor(
    private studentApiService: StudentApiService,
    public dialog: DialogRef,
    public config: DialogConfig<{ type: StudentAIInterviewType; student: StudentDetail }>,
  ) {}
  type: StudentAIInterviewType;
  title: string;
  student: StudentDetail;
  pageTitle: string;

  isImportInProgress = false;
  fileToUpload: File | null = null;

  ngOnInit() {
    this.type = this.config.data.type;
    this.pageTitle = this.type === StudentAIInterviewType.GPS ? 'GPS' : 'AI面談・AI面接対策';
    this.title = this.type === StudentAIInterviewType.GPS ? 'GPS' : 'PeopleX';
    this.student = this.config.data.student;
  }

  ngOnDestroy() { }

  public close(): void {
    this.dialog.close();
  }

  onInputChanged(event): void {
    this.fileToUpload = event && event.srcElement && event.srcElement.files ? event.srcElement.files[0] : this.fileToUpload;
  }

  onImport() {
    if (!this.fileToUpload || this.isImportInProgress) {
      return;
    }
    this.isImportInProgress = true;

    this.studentApiService
      .importStudentAIInterviewCSVFile(this.fileToUpload, String(this.student.id), this.type)
      .subscribe((resp: { id: number }) => {
        this.isImportInProgress = false;

        if (this.fileInput) {
          this.fileInput.value = undefined;
        }

        // Close Dialog
        this.dialog.close({ saved: true });
      }, () => {
        this.isImportInProgress = false;

        if (this.fileInput) {
          this.fileInput.value = undefined;
        }
      });
  }
}
